import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useRouter } from "next/navigation";

import mockHeader from "mock/header";

import IconArrow from "assets/svg/chevron-down.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import HeaderMenuSub from "components/header-menu-sub";

import {
  headerForRentButton,
  headerForSaleButton,
  headerOurServicesButton,
  headerProjectsButton,
  headerRealEstateNewsButton,
} from "@/constants/test-selector-ids";

import styles from "./styles.module.css";

const HeaderMenu = ({ categoryTree }) => {
  const router = useRouter();

  const [activeMenu, setActiveMenu] = useState(null);

  const handleTriggerSubMenu = (e, directive, type) => {
    e.stopPropagation();

    setTimeout(() => {
      setActiveMenu(activeMenu === type ? null : type);
    }, 200);

    if (!["satilik", "kiralik", "hizmetlerimiz", "projeler"].includes(type) && directive === "open") {
      handleSetGa4Event(type);
    }
  };

  const handleSetGa4Event = (eventLabel) => {
    Ga4WithEventParameters({
      eventName: "header",
      eventParameters: { label: `click||${eventLabel}` },
    });
  };

  const handleNavigation = (url, eventParam) => {
    handleSetGa4Event(eventParam);
    router.push(url);
  };

  const getHeaderMenuSub = ({ openedKey, url }) => (
    <HeaderMenuSub isOpen={activeMenu === openedKey} data={categoryTree.find((x) => x.url === url)} slug={openedKey} />
  );

  return (
    <ul className={styles.menu}>
      <li>
        <div
          role="button"
          tabIndex={0}
          onClick={(e) => handleTriggerSubMenu(e, "open", "satilik")}
          onBlur={(e) => handleTriggerSubMenu(e, "close")}
          data-test-selector={headerForSaleButton}
        >
          Satılık
          <span
            className={classNames({
              [styles.icon]: true,
              [styles.iconTransformed]: activeMenu === "satilik",
            })}
          >
            <IconArrow />
          </span>
        </div>
        {getHeaderMenuSub({ openedKey: "satilik", url: "satilik" })}
      </li>
      <li>
        <div
          role="button"
          tabIndex={1}
          onClick={(e) => handleTriggerSubMenu(e, "open", "kiralik")}
          onBlur={(e) => handleTriggerSubMenu(e, "close")}
          data-test-selector={headerForRentButton}
        >
          Kiralık
          <span
            className={classNames({
              [styles.icon]: true,
              [styles.iconTransformed]: activeMenu === "kiralik",
            })}
          >
            <IconArrow />
          </span>
        </div>
        {getHeaderMenuSub({ openedKey: "kiralik", url: "kiralik" })}
      </li>
      <li>
        <div
          role="button"
          tabIndex={2}
          onClick={(e) => handleTriggerSubMenu(e, "open", "projeler")}
          onBlur={(e) => handleTriggerSubMenu(e, "close")}
          data-test-selector={headerProjectsButton}
        >
          Projeler
          <span
            className={classNames({
              [styles.icon]: true,
              [styles.iconTransformed]: activeMenu === "projeler",
            })}
          >
            <IconArrow />
          </span>
        </div>
        {getHeaderMenuSub({ openedKey: "projeler", url: "satilik-konut/projeler" })}
      </li>
      <li>
        <div
          role="button"
          tabIndex={3}
          onClick={(e) => handleTriggerSubMenu(e, "open", "hizmetlerimiz")}
          onBlur={(e) => handleTriggerSubMenu(e, "close")}
          data-test-selector={headerOurServicesButton}
        >
          Hizmetlerimiz
          <span
            className={classNames({
              [styles.icon]: true,
              [styles.iconTransformed]: activeMenu === "hizmetlerimiz",
            })}
          >
            <IconArrow />
          </span>
        </div>
        <HeaderMenuSub isOpen={activeMenu === "hizmetlerimiz"} data={mockHeader.ourServices} />
      </li>
      <li>
        <div
          role="button"
          tabIndex={4}
          onClick={() => handleNavigation(`/haber/`, "emlak-haberleri")}
          data-test-selector={headerRealEstateNewsButton}
        >
          Emlak Haberleri
        </div>
      </li>
    </ul>
  );
};

HeaderMenu.propTypes = {
  categoryTree: PropTypes.array,
};

export default HeaderMenu;
